import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {User} from '../../../classes/user';
import {UserService} from '../../../services/user';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {Role} from '../../../classes/role';
import {RoleService} from '../../../services/role';
import {Pa} from "../../../classes/pa";
import {switchMap} from "rxjs/operators";
import {from} from "rxjs";
import {PaService} from "../../../services/pa";

@Component({
    selector: 'app-user-update',
    templateUrl: './user-update.component.html',
    styleUrls: ['./user-update.component.css']
})
export class UserUpdateComponent implements OnInit {
    user!: User;
    userUpdateResult = true;
    roles: Array<Role> = [];
    pas: Array<Pa> = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private userService: UserService,
                private roleService: RoleService,
                private paService: PaService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.userService.getByID(params.get('id'))
                .subscribe({
                    next: (user: any) => {
                        this.user = user;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
        this.roleService.getAll()
            .subscribe({
                next: (roles: any) => {
                    this.roles = roles;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });

        this.paService.getAll()
            .pipe(
                switchMap((pasData: any) => from(pasData))
            )
            .subscribe({
                next: (pa: any) => {
                    this.pas.push(pa);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });
    }

    onSubmit() {
        this.user.role.id_role = this.user.fk_id_role;
        if (this.user.fk_id_role !== 3) {
            this.user.fk_id_pa = null;
        }
        this.userService.update(this.user)
            .subscribe({
                next: () => {
                    this.router.navigate(['/user']);
                },
                error: (err: HttpErrorResponse) => {
                    this.userUpdateResult = false;
                    console.log(err);
                }
            });
    }

}
